import React, { useEffect, useState } from 'react'
import { Pagination } from '@mui/material'
import { FormattedMessage } from 'react-intl'

import { API, API_ROUTER } from '../../../../api'

import CommunityItem from '../../../../components/list-items/components/communityItem'
import { Preloader } from '../../../../components/UI'

import styles from './styles.module.scss'

export const CommunityList = () => {
  const [communityList, setCommunityList] = useState()
  const [pageCommunity, setPageCommunity] = useState(1)
  const [isLoading, setIsLoading] = useState(false)

  const getCommunity = () => {
    setIsLoading(true)
    const useParams = {}

    API.request({
      useParams,
      ...API_ROUTER.follow.getfollowedCommunities,
      pathKeys: {
        page: pageCommunity,
        limit: 10,
      },
    })
      .then(res => {
        setCommunityList(res)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  const handleChangeCommunities = (event, value) => {
    setPageCommunity(value)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  useEffect(() => {
    getCommunity()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageCommunity])

  if (isLoading) {
    return <Preloader />
  }

  return (
    <section className={styles.calendarList}>
      {!communityList?.follows?.length && (
        <div className='empty-data'>
          <FormattedMessage id='calendar.noCommunities' />
        </div>
      )}

      <article>
        <ul>
          {communityList?.follows?.map(communities => (
            <CommunityItem {...communities} key={communities.id} />
          ))}
        </ul>
      </article>

      {!communityList?.paginator?.hasNextPage |
        (communityList?.follows?.length > 9) && (
        <div className={styles.paginatorWrapper}>
          <Pagination
            classes={{ ul: styles.pagination }}
            count={communityList?.paginator?.lastPage}
            page={communityList?.paginator.currentPage}
            onChange={handleChangeCommunities}
            variant='outlined'
          />
        </div>
      )}
    </section>
  )
}

export default CommunityList
